const environmentMap: Record<string, string> = {
  dev: 'https://apik.zagforward.com',
  test: 'https://apik.carvanatech.com',
  prod: 'https://apik.carvana.io'
};

function withEnvironment(path: string) {
  return (environment: string): string => environmentMap[environment] + path;
}

export const inventory = withEnvironment('/merch/search/api/v2/search');
